// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_authLogo__ph5e2 {
  width: 53px;
  height: 73px;
}

.styles_pageTitle__HZJDN {
  font: var(--typography-h1);
  color: var(--color-black);
  margin: 0;
  padding: 0;
}

.styles_settingsForm__hQyCA {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
@media (min-width: 768px) {
  .styles_settingsForm__hQyCA {
    gap: 24px;
  }
}

.styles_formSection__Git0d {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.styles_sectionLabel__d3WUC {
  font: var(--typography-body-m-medium);
  color: var(--color-black);
  text-align: left;
}
.styles_sectionLabel__d3WUC.styles_required__Ta5Uo::after {
  content: " *";
  color: var(--color-error, #dc3545);
  font-weight: 500;
}

.styles_sectionDescription__aSdI3 {
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary, #666);
  margin: 0;
  line-height: 1.5;
}

.styles_nameFields__vNuIA {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
@media (min-width: 768px) {
  .styles_nameFields__vNuIA {
    gap: 24px;
  }
}

.styles_buttonContainer__JxMJf {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
@media (min-width: 768px) {
  .styles_buttonContainer__JxMJf {
    gap: 8px;
  }
}

.styles_saveButton__IqTa9,
.styles_signOutButton__c7G4d,
.styles_replayTourButton__D72Aq {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: opacity 0.2s ease;
}
.styles_saveButton__IqTa9:disabled,
.styles_signOutButton__c7G4d:disabled,
.styles_replayTourButton__D72Aq:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.styles_inputContainer__LY0pu.styles_error__Fu1FX {
  border-color: var(--color-error, #dc3545);
}
.styles_inputContainer__LY0pu.styles_error__Fu1FX:focus-within {
  border-color: var(--color-error, #dc3545);
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);
}

.styles_errorMessage__WySnh {
  font: var(--typography-body-s-regular);
  color: var(--color-error, #dc3545);
  margin-top: 4px;
  min-height: 18px;
}

.styles_loadingContainer__QKOLG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: 16px;
}

.styles_loadingText__ruIzY {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary, #666);
}`, "",{"version":3,"sources":["webpack://./src/screens/account-settings/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,0BAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAAF;ACVE;EDMF;IAOI,SAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,qCAAA;EACA,yBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;AACJ;;AAGA;EACE,sCAAA;EACA,wCAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAAF;AC/CE;ED2CF;IAOI,SAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AACF;AC3DE;EDsDF;IAOI,QAAA;EAEF;AACF;;AACA;;;EAGE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,6BAAA;AAEF;AAAE;;;EACE,YAAA;EACA,mBAAA;AAIJ;;AAAA;EACE,yCAAA;AAGF;AADE;EACE,yCAAA;EACA,4CAAA;AAGJ;;AACA;EACE,sCAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;AAEF;;AACA;EACE,sCAAA;EACA,wCAAA;AAEF","sourcesContent":["@import \"mixins\";\n.authLogo {\n  width: 53px;\n  height: 73px;\n}\n\n.pageTitle {\n  font: var(--typography-h1);\n  color: var(--color-black);\n  margin: 0;\n  padding: 0;\n}\n\n.settingsForm {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n\n  @include md {\n    gap: 24px;\n  }\n}\n\n.formSection {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.sectionLabel {\n  font: var(--typography-body-m-medium);\n  color: var(--color-black);\n  text-align: left;\n\n  &.required::after {\n    content: ' *';\n    color: var(--color-error, #dc3545);\n    font-weight: 500;\n  }\n}\n\n.sectionDescription {\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary, #666);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.nameFields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n\n  @include md {\n    gap: 24px;\n  }\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n\n  @include md {\n    gap: 8px;\n  }\n}\n\n.saveButton,\n.signOutButton,\n.replayTourButton {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: opacity 0.2s ease;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.inputContainer.error {\n  border-color: var(--color-error, #dc3545);\n\n  &:focus-within {\n    border-color: var(--color-error, #dc3545);\n    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);\n  }\n}\n\n.errorMessage {\n  font: var(--typography-body-s-regular);\n  color: var(--color-error, #dc3545);\n  margin-top: 4px;\n  min-height: 18px;\n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  gap: 16px;\n}\n\n.loadingText {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary, #666);\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authLogo": `styles_authLogo__ph5e2`,
	"pageTitle": `styles_pageTitle__HZJDN`,
	"settingsForm": `styles_settingsForm__hQyCA`,
	"formSection": `styles_formSection__Git0d`,
	"sectionLabel": `styles_sectionLabel__d3WUC`,
	"required": `styles_required__Ta5Uo`,
	"sectionDescription": `styles_sectionDescription__aSdI3`,
	"nameFields": `styles_nameFields__vNuIA`,
	"buttonContainer": `styles_buttonContainer__JxMJf`,
	"saveButton": `styles_saveButton__IqTa9`,
	"signOutButton": `styles_signOutButton__c7G4d`,
	"replayTourButton": `styles_replayTourButton__D72Aq`,
	"inputContainer": `styles_inputContainer__LY0pu`,
	"error": `styles_error__Fu1FX`,
	"errorMessage": `styles_errorMessage__WySnh`,
	"loadingContainer": `styles_loadingContainer__QKOLG`,
	"loadingText": `styles_loadingText__ruIzY`
};
export default ___CSS_LOADER_EXPORT___;
